import React, { FC, useCallback } from 'react';
import { Form, Layout, Button, Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { noop } from 'lodash';

import { Right, SpaceBetween } from './styled';

const { Content, Sider, Footer } = Layout;

interface IDetailsForm {
  onSubmit: (values: any) => void;
  onDelete?: () => void;
  // @ts-ignore
  onPreview?: (form: Form) => void;
  deleteConfirmMessage?: string;
  loading: boolean;
  loadingPreview?: boolean;
  submitButtonText: string;
  sidebarRender?: () => any;
  initialValues?: { [key: string]: any };
  withSidebar?: boolean;
  children?: React.ReactNode;
}

export const DetailsForm: FC<IDetailsForm> = ({
  onSubmit,
  onDelete = noop,
  onPreview = noop,
  deleteConfirmMessage = '',
  loading,
  loadingPreview = false,
  submitButtonText,
  sidebarRender = () => <></>,
  initialValues = {},
  children,
  withSidebar = false,
}) => {
  const history = useHistory();
  const [form] = Form.useForm();

  const confirm = useCallback(() => {
    Modal.confirm({
      title: 'Löschen',
      content: deleteConfirmMessage,
      okText: 'Löschen',
      cancelText: 'Abbrechen',
      onOk: onDelete,
      icon: <ExclamationCircleOutlined style={{ color: 'red' }} />,
    });
  }, [deleteConfirmMessage, onDelete]);

  const preview = () => {
    onPreview(form);
  };

  return (
    <Form
      form={form}
      initialValues={{
        ...initialValues,
      }}
      onFinish={onSubmit}
      layout="vertical"
    >
      <Layout>
        <Content style={{ height: 'calc(100vh - 164px)', overflow: 'auto', paddingRight: 20 }}>
          <Layout>
            <Content>{children}</Content>

            {withSidebar && (
              <Sider
                width={screen.width < 768 ? '100%' : '500px'}
                style={{
                  background: 'transparent',
                  paddingLeft: 30,
                  paddingRight: 10,
                }}
              >
                {sidebarRender()}
              </Sider>
            )}
          </Layout>
        </Content>

        <Footer
          style={{
            display: 'flex',
            alignItems: 'center',
            height: 60,
            padding: 10,
            border: '1px solid #ccc',
            borderWidth: '1px 0',
          }}
        >
          <SpaceBetween>
            {onDelete !== noop && (
              <Button type="primary" danger onClick={confirm}>
                Löschen
              </Button>
            )}

            <Right>
              <Button style={{ marginRight: 20 }} onClick={() => history.goBack()}>
                Abbrechen
              </Button>

              {onPreview !== noop && (
                <Button style={{ marginRight: 20 }} onClick={preview} loading={loadingPreview}>
                  Vorschau
                </Button>
              )}

              <Button type="primary" htmlType="submit" loading={loading}>
                {submitButtonText}
              </Button>
            </Right>
          </SpaceBetween>
        </Footer>
      </Layout>
    </Form>
  );
};
